import React, { useEffect } from "react";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useSocketChannel } from "src/_common/hooks/custom/useSocketChannel";
import { SOCKET_CHANNEL } from "src/_config";

const SocketImplementations = () => {
  const eventStartDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.START_EVENT);
  const performanceStartPickDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.PERFORMANCE_START_PICK);
  const performanceEndDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.END_ALL_EVENT);
  const winnerDeclaredDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.WINNER);
  const groupGlowDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.GROUP_GLOW);
  const glowEventDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.EVENT_GLOW);

  const eventAction = useAppEventAction();

  useEffect(() => {
    if (eventStartDataFromSocket) {
      console.log({ eventStartDataFromSocket });
      eventAction.eventStatusUpdate(eventStartDataFromSocket);
    }
  }, [eventStartDataFromSocket]);

  useEffect(() => {
    if (performanceEndDataFromSocket) {
      console.log("performanceEndDataFromSocket", performanceEndDataFromSocket);
      eventAction.performanceEndAllEvents(performanceEndDataFromSocket);
    }
  }, [performanceEndDataFromSocket]);

  useEffect(() => {
    if (winnerDeclaredDataFromSocket) {
      console.log("winnerDeclaredDataFromSocket", winnerDeclaredDataFromSocket);
      eventAction.winnerDeclared(winnerDeclaredDataFromSocket);
    }
  }, [winnerDeclaredDataFromSocket]);

  useEffect(() => {
    if (performanceStartPickDataFromSocket) {
      console.log("performanceStartPickDataFromSocket", performanceStartPickDataFromSocket);
      eventAction.performanceStartPick(performanceStartPickDataFromSocket);
    }
  }, [performanceStartPickDataFromSocket]);

  useEffect(() => {
    if (groupGlowDataFromSocket) {
      console.log("groupGlowDataFromSocket", groupGlowDataFromSocket);
      eventAction.groupGlow(groupGlowDataFromSocket);
    }
  }, [groupGlowDataFromSocket]);

  useEffect(() => {
    if (glowEventDataFromSocket) {
      eventAction.rodeoEventGlow(glowEventDataFromSocket);
    }
  }, [glowEventDataFromSocket]);

  return <></>;
};

export default SocketImplementations;
